export { CURRENCY_LABEL } from '../constants/currency';

export const formatD10S = (value) => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return '0.00';
  }
  return numeric.toFixed(2);
};
